import { AccessLevel } from "@/graphql/generated/operations";
import type { MatchAccessInput } from "./use-match-editor";

// Shared access-role vocabulary for the match settings / new-match dialogs.
// Kept out of MatchModals so those files export only components (react-refresh).
export type AssignableRole = "admin" | "editor" | "reader";

export type AccessRowDraft = {
  personId: string;
  formattedName: string;
  role: AssignableRole;
};

export const ROLE_LABEL_KEYS: Record<AssignableRole, { id: string; defaultMessage: string }> = {
  admin: { id: "match.modal.roleAdmin", defaultMessage: "Admin" },
  editor: { id: "match.modal.roleEditor", defaultMessage: "Bearbeiter:in" },
  reader: { id: "match.modal.roleReader", defaultMessage: "Leser:in" },
};

export const ROLE_HINT_KEYS: Record<AssignableRole, { id: string; defaultMessage: string }> = {
  admin: { id: "match.modal.roleHintAdmin", defaultMessage: "Alle Inhalte + Zugriff verwalten" },
  editor: { id: "match.modal.roleHintEditor", defaultMessage: "Inhalte bearbeiten" },
  reader: { id: "match.modal.roleHintReader", defaultMessage: "Nur ansehen" },
};

export function roleToAxes(role: AssignableRole): Omit<MatchAccessInput, "personId"> {
  switch (role) {
    case "admin":
      return {
        prepare: AccessLevel.Write,
        design: AccessLevel.Write,
        discover: AccessLevel.Write,
        match: AccessLevel.Write,
      };
    case "editor":
      return {
        prepare: AccessLevel.Read,
        design: AccessLevel.Write,
        discover: AccessLevel.Write,
        match: AccessLevel.Write,
      };
    case "reader":
      return {
        prepare: AccessLevel.Read,
        design: AccessLevel.Read,
        discover: AccessLevel.Read,
        match: AccessLevel.Read,
      };
  }
}

export function axesToRole(axes: Omit<MatchAccessInput, "personId">): AssignableRole {
  if (axes.prepare === AccessLevel.Write) return "admin";
  if (
    axes.design === AccessLevel.Write ||
    axes.discover === AccessLevel.Write ||
    axes.match === AccessLevel.Write
  ) {
    return "editor";
  }
  return "reader";
}
